import React, { useState, useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../../AuthContext/AuthContext';
import {
  Box,
  Card,
  CardContent,
  CardMedia,
  Typography,
  IconButton,
  Button,
  Grid,
  Tooltip,
  Chip,
  CircularProgress,
  Tabs,
  Tab,

  Paper
} from '@mui/material';
import { CheckCircle } from '@mui/icons-material';
import {
  FavoriteBorder,
  Favorite,
  Share,
  ThumbUpAltOutlined,
  ThumbUpAlt,
  Call,
  Chat,
  LocationOn,
  ChevronLeft,
  ChevronRight,
  ArrowForwardIos,
  ArrowBackIos
} from '@mui/icons-material';
import axios from 'axios';
import buildingImage from './../../../Images/house.jpeg';
import CustomSearchBar from './../Lease Module/CustomSearch';
import BottomNavbar from './CustomNavbarHotProperties';
import { BASE_URL } from './../../Api/ApiUrls';
import LimitModal from './../Buy Module/LimitModal';
import SubscriptionModal from './../Buy Module/SubscriptionModal';
import AlertModal from './../Buy Module/AlertModal';

const PropertyCard = () => {
  const navigate = useNavigate();
  const [searchQuery, setSearchQuery] = useState('');
  const { userId, logout } = useContext(AuthContext);
  const [saved, setSaved] = useState(() => {
    const stored = localStorage.getItem('savedHot');
    return stored ? JSON.parse(stored) : [];
  });
  const [likedCards, setLikedCards] = useState({});
  const [properties, setProperties] = useState([]);
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentImageIndex, setCurrentImageIndex] = useState({});
  const [selectedType, setSelectedType] = useState(null);
  const [selectedProperty, setSelectedProperty] = useState(null);
  const [savedProperties, setSavedProperties] = useState([]);
  const [cartItems, setCartItems] = useState([]);
  const [saving, setSaving] = useState({});
  const [priceFilter, setPriceFilter] = useState(null);
  const [isSubscribed, setIsSubscribed] = useState(false);
  const [showLimitModal, setShowLimitModal] = useState(false);
  const [userActivities, setUserActivities] = useState([]);
  const [showSubscribeModal, setShowSubscribeModal] = useState(false);
  const [featureRequested, setFeatureRequested] = useState('');
  const [locationLoading, setLocationLoading] = useState({});
  const [userPlan, setUserPlan] = useState(null);
  const [showAlertModal, setShowAlertModal] = useState(false);
  const [pendingAction, setPendingAction] = useState(null);
  const [currentPropertyId, setCurrentPropertyId] = useState(null);
  const [activeTab, setActiveTab] = useState('buy'); // 'buy' or 'accessed'


  // Add this handler function
  const handlePriceFilterChange = (range) => {
    setPriceFilter(range);
  };
  const rentalTypes = [
    "PLOT/LAND", "VILLA", "APARTMENT"
  ];

  const rentalTypeDisplayMap = {
    "PLOT/LAND": "PLOTS",
    "VILLA": "VILLAS",
    "APARTMENT": "APARTMENTS"
  };
  useEffect(() => {
    const fetchData = async () => {
      try {
        const categoriesResponse = await axios.get(`${BASE_URL}/property-category/`);
        setCategories(categoriesResponse.data);

        const propertiesResponse = await axios.get(`${BASE_URL}/property/`);
        // const filtered = propertiesResponse.data
        //   .sort((a, b) => new Date(b.created_at) - new Date(a.created_at)) // Sort by created_at DESC
        //   .filter(item =>
        //     item.type && item.type.toLowerCase().includes("sell")
        //   );
        const filtered = propertiesResponse.data
          .sort((a, b) => {
            const dateA = new Date(a.boost_date || a.created_at);
            const dateB = new Date(b.boost_date || b.created_at);
            return dateB - dateA; // Descending order
          })
          .filter(item =>
            item.type == "best-deal" && item.Admin_status == "Approved"
          );


        const parsed = filtered.map(item => {
          const parseCoord = (coord) => {
            if (!coord) return null;
            const cleaned = coord.replace(/"/g, '').replace(':', '.');
            return parseFloat(cleaned);
          };

          const matchedCategory = categoriesResponse.data.find(
            cat => cat.category_id == item.category_id
          );

          const categoryName = matchedCategory ? matchedCategory.category : 'Property';

          // Get all images or default to buildingImage
          const images = item.property_images?.length > 0
            ? item.property_images.map(img => `${BASE_URL}${img.image}`)
            : [buildingImage];

          return {
            id: item.property_id,
            title: categoryName,
            location: item.location || 'Not specified',
            price: `₹${item.price?.toLocaleString()}`,
            date: item.created_at?.split('T')[0],
            facing: item.facing?.replace(/"/g, '') || 'N/A',
            area: item.site_area ? `${item.site_area} sq ft` : 'N/A',
            dimensions: item.roadwidth ? `${item.roadwidth} ft road` : 'N/A',
            posted_by: item.posted_by?.replace(/"/g, '') || 'Agent',
            lat: parseCoord(item.lat),
            long: parseCoord(item.long),
            length: item.length,
            width: item.width,
            mobile_no: item.mobile_no,
            admin_mobile: item.admin_mobile,        
            property_name: item.property_name,
            owner: item.user_id,
            images: images, // Now using all images
            propertyData: item
          };
        });

        setProperties(parsed);
        // Initialize current image index for each property
        const initialIndexes = {};
        parsed.forEach(property => {
          initialIndexes[property.id] = 0;
        });
        setCurrentImageIndex(initialIndexes);
      } catch (error) {
        console.error('Error fetching data:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const handleNextImage = (propertyId, e) => {
    e.stopPropagation();
    setCurrentImageIndex(prev => {
      const currentIndex = prev[propertyId];
      const property = properties.find(p => p.id == propertyId);
      const nextIndex = (currentIndex + 1) % property.images.length;
      return {
        ...prev,
        [propertyId]: nextIndex
      };
    });
  };

  const handlePrevImage = (propertyId, e) => {
    e.stopPropagation();
    setCurrentImageIndex(prev => {
      const currentIndex = prev[propertyId];
      const property = properties.find(p => p.id == propertyId);
      const prevIndex = (currentIndex - 1 + property.images.length) % property.images.length;
      return {
        ...prev,
        [propertyId]: prevIndex
      };
    });
  };
  // const rentalTypes = [
  //   "PLOT/LAND", "COMMERCIAL LAND/PLOT", "RENT WITH DUPLEX BUILDING", "DUPLEX HOUSE",
  //   "RENTAL BUILDING", "PG-OFFICES", "FLAT", "VILLA",
  //   "COMMERCIAL BUILDING", "APARTMENT", "JV/JD"
  // ];

  // useEffect(() => {
  //   const checkSubscription = async () => {
  //     try {
  //       console.log('Checking subscription for user:', userId);
  //       const response = await axios.get(`${BASE_URL}/Get-all-plan/${userId}/`);
  //       const subscriptions = response.data;

  //       console.log('Found subscriptions:', subscriptions);

  //       const activeSubscription = subscriptions.find(
  //         (sub) => sub.status === true && sub.user_type === "Buyer"
  //       );

  //       if (activeSubscription) {
  //         console.log('User is subscribed and is a Buyer');
  //         setIsSubscribed(true);
  //         setUserPlan(activeSubscription); // Store the active subscription
  //       } else {
  //         console.log('User is NOT subscribed or not a Buyer');
  //         setIsSubscribed(false);
  //         setUserPlan(null);
  //       }
  //     } catch (error) {
  //       console.error('Error checking subscription:', error);
  //       setIsSubscribed(false);
  //       setUserPlan(null);
  //     }
  //   };

  //   if (userId) {
  //     checkSubscription();
  //   } else {
  //     console.log('No user ID, defaulting to non-subscribed state');
  //     setIsSubscribed(false);
  //     setUserPlan(null);
  //   }
  // }, [userId]);

  // Fetch and filter user activities

  useEffect(() => {
    const checkSubscription = async () => {
      try {
        console.log('Checking subscription for user:', userId);
        const response = await axios.get(`${BASE_URL}/Get-user-plan/${userId}/`);
        const subscriptions = response.data;

        console.log('Found subscriptions:', subscriptions);

        // Check if any subscription matches the Buyer type
        const buyerSubscription = Array.isArray(subscriptions)
          ? subscriptions.find(sub => sub.user_type === "Buyer")
          : null;

        if (buyerSubscription) {
          console.log('User has a Buyer subscription');
          setIsSubscribed(true);
          setUserPlan(buyerSubscription); // Store the matching subscription
        } else {
          console.log('User does NOT have a Buyer subscription');
          setIsSubscribed(false);
          setUserPlan(null);
        }
      } catch (error) {
        console.error('Error checking subscription:', error);
        setIsSubscribed(false);
        setUserPlan(null);
      }
    };

    if (userId) {
      checkSubscription();
    } else {
      console.log('No user ID, defaulting to non-subscribed state');
      setIsSubscribed(false);
      setUserPlan(null);
    }
  }, [userId]);

  useEffect(() => {
    const fetchUserActivities = async () => {
      if (!userId) {
        console.log('No userId - skipping activity fetch');
        return;
      }

      try {
        console.log(`Fetching activities for user ${userId}`);
        const response = await fetch(`${BASE_URL}/activities/`);

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const allActivities = await response.json();
        console.log('All activities from API:', allActivities);

        // Enhanced filtering with type checking
        const filteredActivities = allActivities.filter(activity => {
          // Check if activity exists and has user_id property
          if (!activity || activity.user_id === undefined) {
            console.warn('Invalid activity object:', activity);
            return false;
          }

          // Compare user_id (convert both to string for safety)
          return String(activity.user_id) === String(userId);
        });

        console.log('Filtered user activities:', filteredActivities);
        setUserActivities(filteredActivities);

      } catch (error) {
        console.error('Error fetching activities:', error);
        setUserActivities([]);
      }
    };

    fetchUserActivities();
  }, [userId]);


  // Fetch saved properties from API on component mount
  useEffect(() => {
    const fetchSavedProperties = async () => {
      try {
        const response = await axios.get(`${BASE_URL}/get-user-cart/${userId}/`);
        setCartItems(response.data);
        setSavedProperties(response.data.map(item => item.property_id));
      } catch (error) {
        console.error('Error fetching saved properties:', error);
      }
    };

    fetchSavedProperties();
  }, [userId]);

  // API functions
  const addToCart = async (propertyId) => {
    try {
      const response = await axios.post(`${BASE_URL}/user-cart/`, {
        user_id: userId,
        property_id: propertyId
      });
      return response.data;
    } catch (error) {
      console.error('Error adding to cart:', error);
      throw error;
    }
  };



  const removeFromCart = async (cartId) => {
    try {
      await axios.delete(`${BASE_URL}/user-cart/${cartId}/`);
    } catch (error) {
      console.error('Error removing from cart:', error);
      throw error;
    }
  };

  const toggleSave = async (property) => {
    const propertyId = property.id;
    setSaving(prev => ({ ...prev, [propertyId]: true }));

    try {
      const isSaved = savedProperties.includes(propertyId);
      const cartItem = cartItems.find(item => item.property_id === propertyId);

      if (isSaved) {
        // Remove from saved
        await removeFromCart(cartItem.cart_id);
        setSavedProperties(prev => prev.filter(id => id !== propertyId));
        setCartItems(prev => prev.filter(item => item.property_id !== propertyId));
      } else {
        // Add to saved
        const newItem = await addToCart(propertyId);
        setSavedProperties(prev => [...prev, propertyId]);
        setCartItems(prev => [...prev, newItem.data]);
      }
    } catch (error) {
      console.error('Error updating saved properties:', error);
      // Optionally show error to user
    } finally {
      setSaving(prev => ({ ...prev, [propertyId]: false }));
    }
  };

  const isSaved = (property) => savedProperties.includes(property.id);
  // Add this function to get accessed properties
  const getAccessedProperties = () => {
    // Filter activities by "Buyer" type
    const buyerActivities = userActivities.filter(
      activity => activity.activity_as === "Buyer"
    );

    const uniquePropertyIds = [...new Set(buyerActivities.map(activity => activity.property_id))];
    return properties.filter(property => uniquePropertyIds.includes(property.id));
  };


  // Replace your filteredProperties logic with this:
  const filteredProperties = activeTab === 'accessed'
    ? getAccessedProperties()
    : properties.filter((property) => {
      const matchesSearch =
        property.title.toLowerCase().includes(searchQuery.toLowerCase()) ||
        property.location.toLowerCase().includes(searchQuery.toLowerCase());

      const matchesType = selectedType
        ? property.title.toLowerCase().includes(selectedType.toLowerCase())
        : true;

      const matchesPrice = priceFilter
        ? property.propertyData.price >= priceFilter.min &&
        property.propertyData.price <= priceFilter.max
        : true;

      return matchesSearch && matchesType && matchesPrice;
    });

  const toggleLike = (id) => {
    setLikedCards((prev) => ({
      ...prev,
      [id]: !prev[id],
    }));
  };

  if (loading) {
    return (
      <Box sx={{
        backgroundColor: 'rgb(239, 231, 221)',
        minHeight: '100vh',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
      }}>
        <Typography>Loading properties...</Typography>
      </Box>
    );
  }

  const checkPropertyLimit = (currentPropertyId) => {
    if (!isSubscribed) {
      console.log('Non-subscriber - access denied');
      setFeatureRequested("Property Access");
      setShowSubscribeModal(true);
      return false;
    }

    // If unlimited access is granted
    if (userPlan?.no_of_properties_unlimited) {
      console.log('User has unlimited property access');
      return true;
    }

    // Filter activities by "Buyer" type
    const buyerActivities = userActivities.filter(
      activity => activity.activity_as === "Buyer"
    );

    const uniqueProperties = new Set(buyerActivities.map(a => a.property_id));
    const isExistingProperty = uniqueProperties.has(currentPropertyId);

    console.log(`User has accessed ${uniqueProperties.size} unique properties as Buyer`);
    console.log(`Is current property already accessed? ${isExistingProperty}`);

    // Get the dynamic limit from user plan, default to 3 if not available
    const propertyLimit = userPlan?.no_of_properties || 10;

    if (uniqueProperties.size >= propertyLimit && !isExistingProperty) {
      console.log(`Property limit (${propertyLimit}) exceeded - showing limit modal`);
      setShowLimitModal(true);
      return false;
    }

    return true;
  };
  const logActivity = async (propertyId, activityType) => {
    // Find the property in the properties state
    const property = properties.find(p => p.id === propertyId);

    if (!property) {
      console.error('Property not found for logging activity');
      return false;
    }

    const postData = {
      user_id: userId,
      property_id: propertyId,
      activity_type: activityType,
      property_by: property.owner,
      activity_as: "Buyer" // Always set to "Buyer" for this page
    };

    console.log('Posting activity data:', postData);

    try {
      const response = await fetch(`${BASE_URL}/activities/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(postData)
      });

      if (!response.ok) {
        const errorData = await response.json();
        console.error('Failed to log activity:', errorData);
        throw new Error(errorData.message || 'Failed to log activity');
      }

      const newActivity = await response.json();
      console.log('Activity logged successfully:', newActivity);
      setUserActivities(prev => [...prev, newActivity]);
      return true;
    } catch (err) {
      console.error("Error logging activity:", err);
      return false;
    }
  };

  const handleAction = async (e, propertyId, actionName, actionCallback, activityType) => {
  e.stopPropagation();

  if (!isSubscribed) {
    setFeatureRequested(actionName);
    setShowSubscribeModal(true);
    return;
  }

  // Check property limit BEFORE showing alert modal
  if (activityType) {
    const withinLimit = checkPropertyLimit(propertyId);
    if (!withinLimit) {
      return; // Stop if limit exceeded (modal already shown by checkPropertyLimit)
    }
  }

  // Set pending action and show alert modal
  setPendingAction(() => async () => {
    try {
      // Execute the action
      await actionCallback();

      // Re-fetch activities to recheck the limit state after the action
      await fetchUserActivities(); // Re-fetch user activities after the action is done.

      // Log activity if specified
      if (activityType) {
        await logActivity(propertyId, activityType);
      }
    } catch (error) {
      console.error(`Error in ${actionName} action:`, error);
      alert(`Failed to complete ${actionName} action`);
    }
  });

  setCurrentPropertyId(propertyId);
  setShowAlertModal(true);
};
const fetchUserActivities = async () => {
  if (!userId) {
    console.log('No userId - skipping activity fetch');
    return;
  }

  try {
    console.log(`Fetching activities for user ${userId}`);
    const response = await fetch(`${BASE_URL}/activities/`);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const allActivities = await response.json();
    console.log('All activities from API:', allActivities);

    // Enhanced filtering with type checking
    const filteredActivities = allActivities.filter(activity => {
      // Check if activity exists and has user_id property
      if (!activity || activity.user_id === undefined) {
        console.warn('Invalid activity object:', activity);
        return false;
      }

      // Compare user_id (convert both to string for safety)
      return String(activity.user_id) === String(userId);
    });

    console.log('Filtered user activities:', filteredActivities);
    setUserActivities(filteredActivities);

    // Re-check the property limit after fetching activities
    checkPropertyLimit(currentPropertyId); // Make sure to use currentPropertyId after updating

  } catch (error) {
    console.error('Error fetching activities:', error);
    setUserActivities([]);
  }
};



const handleCallClick = (e, property) => {
  handleAction(
    e,
    property.id,
    "Call",
    async () => {
      const phoneNumber = property.admin_mobile || property.mobile_no;
      await navigator.clipboard.writeText(phoneNumber);
      alert(`Copied: ${phoneNumber}`);
    },
    "Call"
  );
};


  const handleMessageClick = (e, property) => {
    handleAction(e, property.id, "Call", async () => {
      navigate('/chat', { state: { property: property.id } });
    }, "Call");
  };

  const handleLikeClick = (e, propertyId) => {
    handleAction(e, propertyId, "Liked", () => {
      toggleLike(propertyId);
    }, "Liked");
  };

  const handleLocationClick = (e, property) => {
    handleAction(e, property.id, "Location", async () => {
      setLocationLoading(prev => ({ ...prev, [property.id]: true }));

      const openInMaps = (url) => {
        setLocationLoading(prev => ({ ...prev, [property.id]: false }));
        window.open(url, '_blank', 'noopener,noreferrer');
      };

      const fallbackUrl = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(property.location)}`;

      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          (position) => {
            const userLat = position.coords.latitude;
            const userLng = position.coords.longitude;
            const mapsUrl = property.lat && property.long
              ? `https://www.google.com/maps/dir/?api=1&origin=${userLat},${userLng}&destination=${property.lat},${property.long}&travelmode=driving`
              : fallbackUrl;
            openInMaps(mapsUrl);
          },
          (error) => {
            console.error("Error getting location:", error);
            openInMaps(fallbackUrl);
          },
          { timeout: 10000 }
        );
      } else {
        openInMaps(fallbackUrl);
      }
    }, "Location");
  };

  const handleWishlistClick = (e, property) => {
    e.stopPropagation();
    handleAction(e, property.id, "Liked", async () => {
      await toggleSave(property);
    }, "Liked");
  };


  return (
    <Box sx={{ backgroundColor: 'rgb(239, 231, 221)', minHeight: '120vh' }}>
      {/* Sticky Search Bar */}
      <Box
        sx={{
          position: 'sticky',
          top: 0,
          zIndex: 1000,
          px: 1,
          py: 1,
          backgroundColor: 'rgb(239, 231, 221)',
        }}
      >
        <CustomSearchBar
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          onPriceFilterChange={handlePriceFilterChange}
        />
      </Box>

      {/* Tabs */}
      <Box sx={{ px: 2, mt: 0, pb: 2 }}>
        <Tabs
          value={activeTab}
          onChange={(e, newValue) => setActiveTab(newValue)}
          sx={{
            '& .MuiTabs-indicator': {
              backgroundColor: 'black',
              height: 3,
            },
          }}
        >
          <Tab
            label="Hot Properties"
            value="buy"
            sx={{
              textTransform: 'none',
              fontWeight: 'bold',
              color: activeTab === 'buy' ? 'black' : 'text.secondary',
              minWidth: 0,
              mr: 2,
            }}
          />
          <Tab
            label="Accessed Properties"
            value="accessed"
            sx={{
              textTransform: 'none',
              fontWeight: 'bold',
              color: activeTab === 'accessed' ? 'black' : 'text.secondary',
              minWidth: 0,
            }}
          />
        </Tabs>
      </Box>

      {/* Property Types - Only show when in 'rent' tab */}
      {activeTab === 'buy' && (
        <Box sx={{ px: 2 }}>
          <Box
            sx={{
              display: 'flex',
              gap: 1,
              overflowX: 'auto',
              whiteSpace: 'nowrap',
              pb: 1,
            }}
          >
            {rentalTypes.map((type, index) => (
              <Chip
                key={index}
                label={rentalTypeDisplayMap[type] || type}
                variant="filled"
                onClick={() => setSelectedType(prev => (prev == type ? null : type))}
                sx={{
                  flexShrink: 0,
                  bgcolor: selectedType == type ? '#000000' : 'transparent',
                  color: selectedType == type ? '#ffffff' : '#000000',
                  border: '1px solid black',
                  fontWeight: 'bold',
                  '&:hover': {
                    bgcolor: selectedType == type ? '#000000' : 'rgba(0, 0, 0, 0.1)',
                  },
                }}
              />
            ))}
          </Box>
        </Box>
      )}

      <Box sx={{ pb: 8 }}>
        {filteredProperties.length > 0 ? (
          filteredProperties.map((property) => {
            // Move the isAccessed declaration here, before the return statement
            const isAccessed = userActivities.some(activity =>
              activity.property_id === property.id && activity.activity_as === "Buyer"
            );
            return (
              <Card
                key={property.id}
                sx={{
                  mb: 1.2,
                  mx: 2,
                  borderRadius: 3,
                  boxShadow: 2,
                  transition: 'transform 0.2s ease-in-out',
                  '&:hover': { transform: 'scale(1.015)', boxShadow: 4 },
                }}
                onClick={(e) => {
                  const isButtonClick = e.target.closest('button') || e.target.closest('svg');
                  if (!isButtonClick) {
                    navigate('/hot-property-description', { state: { propertyId: property.id, property: property.propertyData } });
                  }
                }}
              >
                <Box position="relative">
                  {/* Carousel */}
                  <Box sx={{ position: 'relative', width: '100%', height: '140px' }}>
                    <CardMedia
                      component="img"
                      image={property.images[currentImageIndex[property.id]]}
                      alt="Property"
                      sx={{
                        width: '100%',
                        height: '140px',
                        objectFit: 'cover',
                        borderTopLeftRadius: 12,
                        borderTopRightRadius: 12,
                      }}
                    />

                    {/* Left/Right Carousel Arrows (hidden by default) */}
                    {property.images.length > 1 && (
                      <>
                        <IconButton
                          sx={{
                            position: 'absolute',
                            top: '50%',
                            left: 8,
                            opacity: 0,
                            transform: 'translateY(-50%)',
                            backgroundColor: 'rgba(255,255,255,0.3)',
                            backdropFilter: 'blur(2px)',
                            '&:hover': {
                              opacity: 1,
                              backgroundColor: 'rgba(255,255,255,0.5)'
                            }
                          }}
                          onClick={(e) => handlePrevImage(property.id, e)}
                        >
                          <ChevronLeft fontSize="small" />
                        </IconButton>
                        <IconButton
                          sx={{
                            position: 'absolute',
                            top: '50%',
                            right: 8,
                            opacity: 0,
                            transform: 'translateY(-50%)',
                            backgroundColor: 'rgba(255,255,255,0.3)',
                            backdropFilter: 'blur(2px)',
                            '&:hover': {
                              opacity: 1,
                              backgroundColor: 'rgba(255,255,255,0.5)'
                            }
                          }}
                          onClick={(e) => handleNextImage(property.id, e)}
                        >
                          <ChevronRight fontSize="small" />
                        </IconButton>
                      </>
                    )}

                    {/* Dot Indicators */}
                    {property.images.length > 1 && (
                      <Box
                        sx={{
                          position: 'absolute',
                          bottom: 10,
                          left: '50%',
                          transform: 'translateX(-50%)',
                          display: 'flex',
                          gap: 1
                        }}
                      >
                        {property.images.map((_, index) => (
                          <Box
                            key={index}
                            onClick={(e) => {
                              e.stopPropagation();
                              setCurrentImageIndex(prev => ({
                                ...prev,
                                [property.id]: index
                              }));
                            }}
                            sx={{
                              width: 8,
                              height: 8,
                              borderRadius: '50%',
                              backgroundColor: currentImageIndex[property.id] == index ? '#1976d2' : '#ccc',
                              cursor: 'pointer',
                              transition: 'background-color 0.3s'
                            }}
                          />
                        ))}
                      </Box>
                    )}

                    <Box sx={{ position: 'absolute', top: 6, right: 6, display: 'flex', gap: 0.8 }}>
                      <Tooltip title="Add to Wishlist">
                        <IconButton
                          sx={{ bgcolor: 'white', boxShadow: 1, p: 0.8 }}
                          onClick={(e) => handleWishlistClick(e, property)}
                          disabled={saving[property.id]}
                        >
                          {isSaved(property) ? <Favorite color="error" /> : <FavoriteBorder />}
                          {saving[property.id] && <CircularProgress size={24} sx={{ position: 'absolute' }} />}
                        </IconButton>
                      </Tooltip>

                      <Tooltip title={isAccessed ? "Already Accessed" : "Share"}>
                        <IconButton
                          sx={{
                            bgcolor: 'white',
                            boxShadow: 1,
                            p: 0.8,
                            color: isAccessed ? 'green' : 'inherit'
                          }}
                          onClick={(e) => e.stopPropagation()}
                        >
                          {isAccessed ? <CheckCircle /> : <Share />}
                        </IconButton>
                      </Tooltip>
                    </Box>
                    <Box sx={{ position: 'absolute', bottom: 6, right: 6 }}>
                      <Tooltip title="Like">
                        <IconButton
                          sx={{ bgcolor: 'white', boxShadow: 1, color: likedCards[property.id] ? 'blue' : 'default', p: 0.8 }}
                          onClick={(e) => handleLikeClick(e, property.id)}
                        >
                          {likedCards[property.id] ? <ThumbUpAlt /> : <ThumbUpAltOutlined />}
                        </IconButton>
                      </Tooltip>
                    </Box>
                  </Box>
                </Box>
                <CardContent sx={{ px: 2, py: 0.2, pb: '7px !important' }}>
                  {/* Title and Price row */}
                  <Box display="flex" justifyContent="space-between" alignItems="flex-start" mb={0.5}>
                    <Typography
                      variant="subtitle1"
                      fontWeight="bold"
                      noWrap
                      sx={{
                        flex: 1,
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        pr: 1
                      }}
                    >
                      {property.title}-{property.property_name}
                    </Typography>
                    <Typography variant="body2" fontWeight="bold" color="primary" noWrap>
                      ₹{Number(String(property.price).replace(/[^0-9]/g, '')).toLocaleString('en-IN')}
                    </Typography>
                  </Box>

                  {/* Location and Date row */}
                  <Box display="flex" justifyContent="space-between" alignItems="center" mb={0.5}>
                    <Typography
                      variant="caption"
                      color="text.secondary"
                      noWrap
                      sx={{
                        flex: 1,
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        pr: 1
                      }}
                    >
                      {property.location}
                    </Typography>
                    <Typography variant="caption" color="text.secondary" noWrap>
                      {new Date(property.date).toLocaleDateString('en-IN', {
                        day: '2-digit',
                        month: '2-digit',
                        year: 'numeric'
                      })}
                    </Typography>
                  </Box>

                  {/* Location Verified and Call button */}
                  <Box display="flex" alignItems="center" mb={1}>
                    <IconButton
                      onClick={(e) => handleLocationClick(e, property)}
                      size="small"
                      sx={{ p: 0.5 }}
                      disabled={locationLoading[property.id]}
                    >
                      {locationLoading[property.id] ? (
                        <CircularProgress size={16} />
                      ) : (
                        <>
                          <LocationOn fontSize="small" sx={{ color: 'primary.main' }} />
                          <Typography variant="caption" color="text.primary" ml={0.5}>
                            Location
                          </Typography>
                        </>
                      )}
                    </IconButton>

                    <Tooltip title="Send Message">
                      <IconButton
                        size="small"
                        onClick={(e) => handleMessageClick(e, property)}
                        sx={{ p: 0, color: 'primary.main', ml: 1 }}
                      >
                        <Chat fontSize="small" />
                      </IconButton>
                    </Tooltip>
                    <Box sx={{ flexGrow: 1 }} />
                    <Button
                      size="small"
                      variant="outlined"
                      color="success"
                      startIcon={<Call fontSize="small" />}
                      sx={{
                        textTransform: 'none',
                        px: 1,
                        py: 0.2,
                        fontSize: '0.7rem',
                        minWidth: 'auto'
                      }}
                      onClick={(e) => handleCallClick(e, property)}
                    >
                      Call
                    </Button>

                  </Box>

                  {/* Property details */}
                  <Box
                    sx={{
                      display: 'flex',
                      border: '1px solid #e0e0e0',
                      borderRadius: 1,
                      overflow: 'hidden',
                    }}
                  >
                    {[
                      { label: 'Facing', value: property.facing || 'N/A' },
                      {
                        label: 'Area',
                        value: (
                          <Box>
                            <Box component="span">{property.area || 'N/A'}</Box>
                            {property.length && property.width && (
                              <Typography
                                component="span"
                                variant="caption"
                                color="text.secondary"
                                sx={{ display: ['none', 'inline'], ml: 0.5 }}
                              >
                                ({property.length} × {property.width})
                              </Typography>
                            )}
                          </Box>
                        )
                      },
                      { label: 'Posted By', value: property.posted_by || 'N/A' },
                    ].map((item, index) => (
                      <Box
                        key={index}
                        sx={{
                          flex: 1,
                          px: 0.5,
                          py: 0.2,
                          textAlign: 'center',
                          borderRight: index < 2 ? '1px solid #e0e0e0' : 'none',
                          minWidth: 0
                        }}
                      >
                        <Typography variant="caption" color="text.secondary" noWrap>
                          {item.label}
                        </Typography>
                        <Typography
                          variant="body2"
                          fontWeight="bold"
                          noWrap={index !== 1} // Allow area to wrap if needed
                          sx={{
                            fontSize: '0.8rem',
                            lineHeight: 1.2
                          }}
                        >
                          {item.value}
                        </Typography>
                      </Box>
                    ))}
                  </Box>
                </CardContent>
              </Card>
            );
          })
        ) : (
          <Box sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '200px',
            px: 2
          }}>
            {activeTab === 'accessed' ? (
              <Typography>You haven't accessed any properties yet</Typography>
            ) : selectedType ? (
              <Typography>
                No properties listed in the "{selectedType}" category
              </Typography>
            ) : (
              <Typography>No properties found matching your search.</Typography>
            )}
          </Box>
        )}
      </Box>
      <Box sx={{ mt: 2 }}></Box>

      {/* Alert Modal */}
      <AlertModal
        open={showAlertModal}
        onClose={() => setShowAlertModal(false)}
        onConfirm={async () => {
          setShowAlertModal(false);
          if (pendingAction) {
            await pendingAction();
          }
        }}
        title="Confirm Action"
        message={`Are you sure you want to perform this action on this property?`}
      />

      {/* Subscription Modal */}
      <SubscriptionModal
        open={showSubscribeModal}
        onClose={() => setShowSubscribeModal(false)}
        onSubscribe={() => {
          setShowSubscribeModal(false);
          navigate('/user-subscription');
        }}
        featureRequested={featureRequested}
      />



      <LimitModal
        open={showLimitModal}
        onClose={() => setShowLimitModal(false)}
        userPlan={userPlan}
      />


      <BottomNavbar />

    </Box>
  );
};

export default PropertyCard;